import { Lock, LockOpen, QrCode } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
// @ts-ignore
import QRCode from 'qrcode.react';
import useQrModal from './use-qr-modal';
import { IStation } from '@helpers/types';

interface IQrModal {
  qr: string;
  pdf?: string;
  station: IStation;
}

const QrModal = (props: IQrModal) => {
  const { open, data, toggle, loading, handlePdf, handleShow, handleClose } =
    useQrModal(props);
  return (
    <>
      <IconButton onClick={handleShow}>
        <QrCode />
      </IconButton>
      <Dialog open={open} maxWidth="xs" onClose={handleClose}>
        <DialogTitle>Código QR de contenedor</DialogTitle>-
        <DialogContent sx={{ textAlign: 'center' }}>
          <Stack spacing={2} alignItems={'center'}>
            <QRCode value={props.qr} size={200} />
            {!loading &&
              data?.container &&
              ['UNASSIGNED', 'SUSPENDED'].includes(data.container.status) && (
                <Stack>
                  <Button
                    variant="outlined"
                    onClick={() => toggle(true)}
                    startIcon={<LockOpen />}
                  >
                    Abrir contenedor
                  </Button>
                  <Typography variant={'caption'}>
                    Para agregar mas guias al contenedor es necesario que active
                    el contenedor
                  </Typography>
                </Stack>
              )}
            {!loading &&
              data?.container &&
              ['ACTIVE'].includes(data.container.status) && (
                <Stack>
                  <Button
                    variant="outlined"
                    onClick={() => toggle(false)}
                    startIcon={<Lock />}
                  >
                    Cerrar contenedor
                  </Button>
                  <Typography variant={'caption'}>
                    Para asignar el contenedor a un veloz es necesario cerrar el
                    contenedor, al realizar esta acción no podrá agregar
                    nuevamente paquetes al contenedor
                  </Typography>
                </Stack>
              )}
          </Stack>
        </DialogContent>
        <DialogActions>
          {props.pdf && (
            <Button onClick={handlePdf} variant="outlined">
              Pdf
            </Button>
          )}
          <Button onClick={handleClose} variant="outlined">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default QrModal;
